export interface ServiceKinSimCampaignsType {
  id: number;
  name: string;
  country: string;
  variation: string;
  coupon: string;
  expiry: string;
  total_urls: number;
  available_urls: number;
  used_urls: number;
  created_at: string;
}

export interface ServiceKinSimCampaignsResponseType {
  url: string;
  promo_code: string;
}

export interface ServiceKinSimUrlsResponseType {
  recipient_email: string;
  message: string;
}

export interface ServiceKinSimUrlsRequestType {
  service_id: number;
  guest_id: number;
  campaign_id: number;
  quantity: number;
}

export interface ServiceKinSimUrlsType {
  url: string;
  promo_code: string;
  email: string;
  status: string;
  claimed_at: string;
  expires_at: string;
}

export interface SerivceKinSimUrlsDetailsType {
  external_id: string;
  campaign_id: number;
  total: number;
  claimed: number;
  redeemed: number;
  urls: ServiceKinSimUrlsType[];
  shared_link_url: string;
}

/** Status filter: matches API values and "all" for no filter. Available URLs are excluded from the list. */
export enum StatusFilter {
  ALL = 'all',
  RESERVED = 'reserved',
  CLAIMED = 'claimed',
  REDEEMED = 'redeemed'
}

export const VIEW_ESIM_DETAILS_STATUS_OPTIONS: { value: StatusFilter; labelKey: string }[] = [
  { value: StatusFilter.ALL, labelKey: 'esim.viewDetailsModal.filterAll' },
  { value: StatusFilter.RESERVED, labelKey: 'esim.viewDetailsModal.filterReserved' },
  { value: StatusFilter.CLAIMED, labelKey: 'esim.viewDetailsModal.filterClaimed' },
  { value: StatusFilter.REDEEMED, labelKey: 'esim.viewDetailsModal.filterRedeemed' }
];

export interface KinSimCampaignDetailsType {
  id: number; // e.g. 5
  name: string; // e.g. "Campaign 4"
  country: string; // e.g. "VIETNAM"
  variation: string; // e.g. "12-days - Unlimited-data"
  coupon: string; // e.g. "Campaign Free 100% coupon"
  expiry: string; // e.g. "1month"
  total_urls: number; // e.g. 100
  available_urls: number; // e.g. 76
  used_urls: number; // e.g. 24
  created_at: string; // e.g. "2026-01-30 08:21:34"
}
